import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class OutreachGuard  {
    constructor(
        private authenticationService: AuthenticationService,
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // for outreach application
        return this.authenticationService.checkUserAlreadyValidLogin().pipe(
            take(1),
            map((valid: boolean) => {
                if (!valid) {
                    this.authenticationService.navigateToLogin();
                }
                return true;
            })
        )
    }

}
